module.exports = __webpack_public_path__ + "static/media/add.84c0722e.svg";